module.exports = __webpack_public_path__ + "media/images/facebook-1a7d8f2e40bb091442e797043a7ad3fc.svg";